import { render, staticRenderFns } from "./GalleryDiaryFolder.vue?vue&type=template&id=46220da2"
import script from "./GalleryDiaryFolder.vue?vue&type=script&lang=js"
export * from "./GalleryDiaryFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports